import React from "react";
import { useHistory } from "react-router-dom";
import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";

import {
  CardWrapper,
  Wrapper,
  ConfirmDialogStyled,
} from "./styles";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "../../companies/list/styles";
import { CNAESModel, CNAESResponseModel } from "../../../../../domain/models/cnae";
import { Filters } from "./filters";
import { FilterType } from "./type";
import { Link } from "../../../../components/cards/navigate-card/styles";
import Icon from "../../../../components/icon";

type PageProps = {
  list?: CNAESResponseModel;
  loading?: boolean;
  handleReload: (filters: FilterType) => void;
  handleDelete: (id: number) => void;
};

const SolicitationListPage: React.FC<PageProps> = ({
  list,
  loading,
  handleReload,
  handleDelete,
}) => {
  const history = useHistory();
  const [remove, setRemove] = React.useState<CNAESModel | undefined>();

  const fields: ItemField[] = [
    {
      title: "Código",
      key: "code",
      renderItem: (data: CNAESModel) =>
        data.code || "-",
    },
    {
      title: "Descrição",
      key: "description",
      renderItem: (data: CNAESModel) =>
        data.description || "-",
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => history.push(`/admin/cnae/${data?.id}?edit=true`)}
            title="Editar"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => history.push(`/admin/cnae/${data?.id}`)}
            title="Ver"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="eye"
              color={theme.colors.lightBlue}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setRemove(data);
            }}
            title="Excluir"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="trash"
              color={theme.colors.red}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];

  return (
    <Wrapper>
      <BackButtom text="Listagem de CNAEs" />
      <CardWrapper>
        <Filters onChange={handleReload} />
        <Link className="button-create" to="/admin/cnae/new" invertColor={false}>
          Novo CNAE <Icon name="arrow-right" />
        </Link>
      </CardWrapper>
      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={(page) => {
          handleReload({ page });
        }}
      />
      <ConfirmDialogStyled
        visible={!!remove}
        onHide={() => setRemove(undefined)}
        header="Você confirma a exclusão desse CNAE?"
        message="Ao excluir, todos os dados relacionados a este CNAE serão removidos. As Notas já geradas perderão a associação com este CNAE."
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          if (remove?.id) {
            handleDelete(remove.id);
          }
        }}
        reject={() => setRemove(undefined)}
      />
    </Wrapper>
  );
};
export default SolicitationListPage;
